<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">添加</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">手机号(登录账号)</div>
            <el-input v-model="add_phone" placeholder="请输入手机号"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">登录密码</div>
            <el-input v-model="add_pwd" type="password" placeholder="请输入登录密码"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">姓名</div>
            <el-input v-model="add_name" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12" class="item">
            <div class="label">身份证号</div>
            <el-input v-model="add_idCard" placeholder="请输入身份证号"></el-input>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="12" class="item">
            <div class="label">机构</div>
            <el-select v-model="institutionCode" placeholder="请选择机构" style="width: 100%">
              <el-option
                  v-for="item in arr_ins"
                  :key="item.institutionCode"
                  :label="item.userName"
                  :value="item.institutionCode">
              </el-option>
            </el-select>
          </el-col>
        </el-row>


      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Add',
  props:['arr_ins'],
  data() {
    return {

      loading: false,

      add_pwd:'',
      add_phone:'',
      add_name:'',
      add_idCard:'',
      institutionCode:'',

    }
  },
  methods: {
    init(){

      this.add_pwd = '';
      this.add_phone='';
      this.add_name='';
      this.add_idCard = "";
      this.institutionCode='';

    },
    closeSelf() {
      this.loading= false
      this.$emit("closeAdd");
    },

    confirm(){

      if(this.add_phone === ''){
        this.$message("请输入手机号");
        return;
      }
      if(this.add_pwd === ''){
        this.$message("请输入密码");
        return;
      }

      if(this.add_name === ''){
        this.$message("请输入名称");
        return;
      }
      if(this.add_idCard === ''){
        this.$message("请输入身份证号");
        return;
      }
      if(this.institutionCode === ''){
        this.$message("请选择机构");
        return;
      }


      if(this.loading){
        return;
      }else{
        this.loading = true;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl+'Mediciner/AddByGov',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          institutionCode:this.institutionCode,

          password:this.add_pwd,
          phone:this.add_phone,
          name:this.add_name,
          idCard:this.add_idCard,

        }

      }).then( (response)=> {
        this.loading = false;
        if(response.data.error == 0){
          this.$emit("closeAdd");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });

    },


  }
}
</script>


